<template>
  <transition name="modal">
    <div class="modal-mask" @click="$emit('closeModal')">
      <div class="modal-wrapper">
        <div class="modal-container" @click.stop>
          <div class="modal-header">
            <slot name="header">
              <h2>Filter</h2>
            </slot>
          </div>
          <div class="modal-body">
            <slot name="body">
              <md-input-container>
                <label>Column</label>
                <md-select
                  v-model="filter.column">
                  <md-option v-for="column in columns" :value="column.name" v-on:selected="setColumnChanged(column)" :key="column.name">
                    {{column.displayName}}
                  </md-option>
                </md-select>
              </md-input-container>
              <md-input-container v-if="!filter.filterObjectSelection">
                <label>Condition</label>
                <md-select
                  v-model="filter.filterCondition" :disabled="filterConditions.length === 0">
                  <md-option v-for="filterCondition in filterConditions" :value="filterCondition" :key="filterCondition" >{{filterCondition}}</md-option>
                </md-select>
              </md-input-container>
              <md-input-container>
                <label>Value</label>
                <md-input v-if="!filter.filterObjectSelection" v-model="filter.filterValue" v-on:change="checkFilter()"></md-input>
                <md-select
                  v-if="filter.filterObjectSelection"
                  v-model="selectedFilterValues" v-on:selected="checkFilter()" multiple>
                  <md-option v-for="(filterValue, index) in filterValues" :value="filterValue+''" :key="index" >{{filterValue}}</md-option>
                </md-select>
              </md-input-container>
              <!--<div class="filter-container" v-if="selectedFilterValues.length > 0">-->
                <!--<md-chip v-for="(filterValue, index) in selectedFilterValues" md-deletable class="md-chip-filter"-->
                  <!--:key="index" @delete="unselectFilterValue(filterValue)">-->
                  <!--{{filterValue}}-->
                <!--</md-chip>-->
              <!--</div>-->
            </slot>
          </div>
          <div class="modal-footer">
            <slot name="footer">
              <md-button class="modal-default-button" :disabled="disableOk" @click.native="$emit('processFilterChange', filter)">
                OK
              </md-button>
              <md-button class="modal-default-button" @click.native="$emit('closeModal')">
                Cancel
              </md-button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<style scoped>
  tbody{
    height:unset;
  }

  .modal-mask {
    position: absolute;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    width: 380px;
    margin: 0px auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
  }

  .modal-header h3 {
    margin-top: 0;
    color: #42b983;
  }

  .modal-body {
    margin: 20px 0;
  }

  .modal-default-button {
    float: right;
  }

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
  .md-input-container input {
    font-size: 16px !important;
  }
  .filter-container div{
    margin-right: 6px;
  }
</style>
<script>
  export default{
    name: 'filterModal',
    components: {
    },
    methods:{
      setColumnChanged: function (column) {
        this.filter.columnDisplayName = column.displayName;
        this.filter.columnName = column.name;
        this.filter.columnType = column.type;
        this.filter.filterObjectSelection = column.filterObjectSelection;
        let self = this;
        if (this.filter.filterObjectSelection && !(this.customFilterOptions && this.customFilterOptions[this.filter.columnName])) {
          this.filter.filterCondition = '';
          this.filter.filterValue = '';
          self.filterValues.length = 0;
          this.data.forEach((item) => {
            if (self.filterValues.indexOf(item[self.filter.columnName]) === -1) {
              console.log('item[self.filter.columnName]',item[self.filter.columnName])
              self.filterValues.push(item[self.filter.columnName]);
            }
          });
          //sort the values
          this.filterValues = this.filterValues.sort();
        } else if (this.customFilterOptions && this.customFilterOptions[this.filter.columnName]) {
          this.filterValues = this.customFilterOptions[this.filter.columnName];
        } else {
          self.selectedFilterValues = [];
        }
        
        this.setFilterConditions(this.filter.columnType);
        this.checkFilter();
        this.$forceUpdate();
      },
      checkFilter: function() {
        let returnValue = true;
        this.filter.filterValues = this.selectedFilterValues;
        let filter = this.filter;
        if (filter && filter.column && filter.column.length > 0 &&
          ((filter.filterValue && filter.filterValue.length > 0 && !filter.filterObjectSelection && filter.filterCondition && filter.filterCondition.length > 0) ||
          (filter.filterObjectSelection && filter.filterValues && filter.filterValues.length > 0))) {
          returnValue = false;
        }
        this.disableOk = returnValue;
      },
      setFilterConditions : function(type){
        this.filterConditions = [];
        this.filterConditions = this.filterConditionsString;
        if(type === 'number'){
          this.filterConditions = this.filterConditionsNumber;
        }
      },
      unselectFilterValue: function (filterValue) {
        let index = this.selectedFilterValues.findIndex(element => element === filterValue)
        if (index > -1)
          this.selectedFilterValues.splice(index, 1);
        this.checkFilter();
      }
    },
    watch: {
      filter: {
        handler: function() {
          this.checkFilter();
        },
        deep: true
      }
    },
    created(){
    },
    mounted(){
      // check if there already is a column set
      if (this.filter.column && this.filter.column.length > 0) {
        this.setFilterConditions(this.filter.columnType);
      }

      
      if (this.data && this.data.length > 0 && this.filter.columnName &&
        !(this.customFilterOptions && this.customFilterOptions[this.filter.columnName])) {
        let self = this;
        self.filterValues.length = 0;
        this.data.forEach((item) => {
          if (self.filterValues.indexOf(item[self.filter.columnName]) === -1) {
            self.filterValues.push(item[self.filter.columnName]);
          }
        });
      } else if (this.customFilterOptions && this.customFilterOptions[this.filter.columnName]) {
        this.filterValues = this.customFilterOptions[this.filter.columnName];
      }

      if (this.filter.filterValues && this.filter.filterValues.length > 0) {
        let lostFilterValues = this.filter.filterValues.filter(i => {
          if(this.filter.columnType == 'boolean') {
            return this.filterValues.indexOf(Boolean(i)) === -1;
          } else {
            return this.filterValues.indexOf(i) === -1;
          }
        });
        this.filterValues = this.filterValues.concat(lostFilterValues);
        this.selectedFilterValues = this.filter.filterValues;
      }
    },
    props:['filter', 'columns', 'data', 'customFilterOptions'],
    data () {
      return {
        filterConditions: [],
        filterConditionsString: ['=', 'Contains', 'Starts with', 'Ends with'],
        filterConditionsNumber: ['=', '>=', '>', '<=', '<', '!='],
        filterConditionsObject: [],
        disableOk: true,
        filterValues: [],
        selectedFilterValues: [],
      };
    },
  };
</script>
